import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#2453d6',
        secondary: '#6b7280',
        accent: '#1c3faa',
        success: '#12a150',
        warning: '#f59e0b',
        error: '#d92d20',
        info: '#2e90fa',
      },
    },
  },
});
